import { Logger } from 'Common/appshell_types/loggerTypes';
import { useLogger } from 'Client/logger/LoggerProvider';

const useRemoteLogger = (remoteName: string) => {
    const logger = useLogger();

    const remoteLogger: Logger = {
        ...logger,
        log: (type, entry, customData) => {
            const microFrontendIndex = { application: remoteName };

            const customDataWithRemoteEntry =
                typeof customData === 'object' ? { ...customData, ...microFrontendIndex } : microFrontendIndex;

            return logger.log(type, entry, customDataWithRemoteEntry);
        },
    };

    return remoteLogger;
};

export default useRemoteLogger;
